import restaurants200Avif from "./restaurants-200.avif";
import restaurants400Avif from "./restaurants-400.avif";
import restaurants600Avif from "./restaurants-600.avif";
import restaurants200Webp from "./restaurants-200.webp";
import restaurants400Webp from "./restaurants-400.webp";
import restaurants600Webp from "./restaurants-600.webp";
import groceries200Avif from "./groceries-200.avif";
import groceries400Avif from "./groceries-400.avif";
import groceries600Avif from "./groceries-600.avif";
import groceries200Webp from "./groceries-200.webp";
import groceries400Webp from "./groceries-400.webp";
import groceries600Webp from "./groceries-600.webp";
import healthcare200Avif from "./healthcare-200.avif";
import healthcare400Avif from "./healthcare-400.avif";
import healthcare600Avif from "./healthcare-600.avif";
import healthcare200Webp from "./healthcare-200.webp";
import healthcare400Webp from "./healthcare-400.webp";
import healthcare600Webp from "./healthcare-600.webp";
import package200Avif from "./package-200.avif";
import package400Avif from "./package-400.avif";
import package600Avif from "./package-600.avif";
import package200Webp from "./package-200.webp";
import package400Webp from "./package-400.webp";
import package600Webp from "./package-600.webp";
import events200Avif from "./events-200.avif";
import events400Avif from "./events-400.avif";
import events600Avif from "./events-600.avif";
import events200Webp from "./events-200.webp";
import events400Webp from "./events-400.webp";
import events600Webp from "./events-600.webp";

const variants = (
  avif200,
  avif400,
  avif600,
  webp200,
  webp400,
  webp600,
) => ({
  avif: [
    { src: avif200, width: 200 },
    { src: avif400, width: 400 },
    { src: avif600, width: 600 },
  ],
  webp: [
    { src: webp200, width: 200 },
    { src: webp400, width: 400 },
    { src: webp600, width: 600 },
  ],
});

export const landingCategoryImages = {
  restaurants: variants(
    restaurants200Avif,
    restaurants400Avif,
    restaurants600Avif,
    restaurants200Webp,
    restaurants400Webp,
    restaurants600Webp,
  ),
  groceries: variants(
    groceries200Avif,
    groceries400Avif,
    groceries600Avif,
    groceries200Webp,
    groceries400Webp,
    groceries600Webp,
  ),
  healthcare: variants(
    healthcare200Avif,
    healthcare400Avif,
    healthcare600Avif,
    healthcare200Webp,
    healthcare400Webp,
    healthcare600Webp,
  ),
  packageDelivery: variants(
    package200Avif,
    package400Avif,
    package600Avif,
    package200Webp,
    package400Webp,
    package600Webp,
  ),
  events: variants(
    events200Avif,
    events400Avif,
    events600Avif,
    events200Webp,
    events400Webp,
    events600Webp,
  ),
};
